import React from 'react'

export default function SubjectHorizontalBar (props) {
  return (
    <div id="horizontalBar">
      <ul>
        <li>English</li>
        <li>Math</li>
        <li>Reading</li>
        <li style={{marginRight: '0px'}}>Science</li>
      </ul>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/SubjectHorizontalBar.js